import useGlobalContext from '$hooks/use-global-context';
import { RESOLVED_TIMEZONE } from '@brahma/utils';
import { useMemo } from 'react';

/**
 * Hook that centralizes the feature flag check for fixed timezone display.
 *
 * When `DISPLAY_TIME_ZONE_ENABLED` is enabled in `activeFeatureConfig`,
 * returns the resolved IANA timezone string (from NEXT_PUBLIC_OPS_PORTAL_TIMEZONE).
 * When disabled or not set, returns `undefined` (browser-local timezone behavior).
 *
 * @returns The resolved timezone string or undefined
 */
const useTimezone = (): string | undefined => {
  const {
    state: { activeFeatureConfig }
  } = useGlobalContext();

  const timezone = useMemo(
    () =>
      activeFeatureConfig?.DISPLAY_TIME_ZONE_ENABLED
        ? RESOLVED_TIMEZONE
        : undefined,
    [activeFeatureConfig?.DISPLAY_TIME_ZONE_ENABLED]
  );

  return timezone;
};

export default useTimezone;
